import assetContext from '../../utils/assetContext';

/**
 * The two wings, in one place.
 *
 * Everything that differs between Work and Life is declared here or in
 * the `[data-wing]` token blocks in wings.css. If a difference needs a
 * third home, that difference is probably a mistake.
 */

const resumeCtx = assetContext(() =>
  require.context('../../assets/work', false, /\.pdf$/));
export const RESUME_URL = resumeCtx.keys().length
  ? resumeCtx(resumeCtx.keys()[0])
  : null;

export const WINGS = {
  work: {
    label: 'work',
    path: '/work',
    title: 'Work',
    // Shown at the foot of the *other* wing, as the way across.
    crossLabel: 'Here to hire, or curious about the code?',
    crossCta: 'See the work',
    sections: [
      { label: 'overview', to: '/work', end: true },
      { label: 'projects', to: '/work/projects' },
      ...(RESUME_URL ? [{ label: 'résumé ↓', to: RESUME_URL, external: true }] : []),
    ],
  },
  life: {
    label: 'life',
    path: '/life',
    title: 'Life',
    crossLabel: 'There is more to me than a stack of job titles.',
    crossCta: 'See the rest',
    sections: [
      { label: 'overview',   to: '/life', end: true },
      { label: 'adventures', to: '/life/adventures' },
      { label: 'writing',    to: '/life/writing' },
      { label: 'log',        to: '/life/log' },
    ],
  },
};

export const OTHER_WING = { work: 'life', life: 'work' };
